import { stripHtmlStrings } from '../../shared/stripHTMLStrings';
import { YoutubeCardProps } from './YoutubeCard';

export const youtubeCardTransformer = (node): YoutubeCardProps => {
    if (!node) return;
    return {
        alignRight: node.field_align_right,
        articleLink: node.field_article_link,
        subtitle: node.field_descriptive_title_text,
        eyebrow: node.field_eyebrow_text,
        showPostDate: node.field_post_date,
        showRuntime: node.field_runtime,
        aspectRatio: node.field_video_aspect_ratio,
        videoTitle: node.field_video_title,
        showViews: node.field_views,
        description: stripHtmlStrings(node.field_youtube_description?.value),
        sectionTitle: node.field_youtube_title,
        youtubeSrcUrl:
            node.relationships?.field_youtube_embed?.field_media_oembed_video,
        parent: node.relationships?.node__newsroom_article?.[0]?.id
            ? `article`
            : `landing`,
    };
};
